import { useEffect, useState } from 'react';
import { Akun } from "../../model/Akun";
import { FormAkunModal, fetchGetAkunAll, RenderTableAkun } from '../../controller/dashboard/Akun';
import { Plus, Search, User, RotateCcw } from 'lucide-react';

export default function DashboardAkun() {
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10); // bisa default 
    const [statusFilter, setStatusFilter] = useState('all');
    const [statusLength, setStatusLength] = useState('10');
    const [showFormModal, setShowFormModal] = useState(false);
    const [statusFormModal, setStatusFormModal] = useState("none")
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [akunData, setAkunData] = useState<Akun[]>([]);
    const [selectedAkun, setSelectedAkun] = useState<Akun | null>(null);

    const filteredAkuns = akunData.filter(akun => {
        const matchesSearch = 
            akun.username.toLowerCase().includes(searchTerm.toLowerCase()) ||
            akun.username.includes(searchTerm) ||
            akun.no_telp.includes(searchTerm) ||
            akun.email_address.includes(searchTerm);
        const matchesStatus = statusFilter === 'all';
        return matchesSearch && matchesStatus;
    });

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentAkuns = filteredAkuns.slice(indexOfFirstItem, indexOfLastItem);
    let totalPages = itemsPerPage > 0 ? Math.ceil(filteredAkuns.length / itemsPerPage) : 0;
    const pageNumbers = totalPages > 0 ? Array.from({ length: totalPages }, (_, i) => i + 1) : [];

    const initDataKaryawan = async () => { 
        setLoading(true);
        try {
            const res = await fetchGetAkunAll();
            if (res.status === 200) {
                setAkunData(res.data); // pastikan API kirim data array karyawan
            } else {
                setAkunData([]);
            }
        } catch (error) {
            console.error(error);
            setAkunData([]);
        } finally {
            setLoading(false);
        }
    }

    const handleShowDetail = (karyawan: Akun) => {
        setSelectedAkun(karyawan);
        setShowDetailModal(true);
    };

    const handleEditAkun = (akun: Akun) => {
        setStatusFormModal('edit');
        setSelectedAkun(akun);
        setShowFormModal(true);
    };

    useEffect(() => {
        initDataKaryawan();
    }, []);

    return (
        <>
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 p-6">
            <div className="max-w-8xl mx-auto">
            {/* Header */}
            <div className="mb-8">
                <div className="flex items-center mb-4">
                <User className="w-8 h-8 text-blue-600 mr-3" />
                <div>
                    <h1 className="text-3xl font-bold text-gray-800">Pengelolaan Akun</h1>
                    <p className="text-gray-600">Kelola data karyawan dan informasi kontrak</p>
                </div>
                </div>
            </div>

            {/* Controls */}
            <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0">
                <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4">
                    {/* Search */}
                    <div className="relative">
                    <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                    <input
                        type="text"
                        placeholder="Cari Username"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full md:w-64"
                    />
                    </div>

                </div>

                <div className="flex space-x-3">
                    <button 
                    onClick={initDataKaryawan}
                    disabled={loading}
                    className="flex items-center px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors">
                    <RotateCcw className={`w-4 h-4 mr-2 ${loading ? "animate-spin" : ""}`} />
                    {loading ? "Memuat..." : "Muat Ulang"}
                    </button>

                    <button
                    onClick={() => { setShowFormModal(true); setStatusFormModal('add')}}
                    className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                    >
                    <Plus className="w-4 h-4 mr-2" />
                    Tambah Akun
                    </button>
                </div>
                </div>
            </div>

            {/* Employee Table */}
            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                    <tr>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Email Address
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Username
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Password
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            No. Telp
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Role
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Aksi
                        </th>
                    </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {
                        loading? 
                        <>
                            <tr>
                            <td colSpan={6} className="text-center py-4 text-gray-500">
                                Sedang Loading . . .
                            </td>
                            </tr>
                        </>
                        :
                        <>
                            <RenderTableAkun data={currentAkuns} onOpenDetail={handleShowDetail} onOpenEdit={handleEditAkun} onRemoveState={initDataKaryawan}/>
                        </>
                        }
                    </tbody>
                </table>
                </div>
            </div>

            {/* Pagination */}
            <div className="mt-6 flex items-center justify-between">
                <div className="text-sm text-gray-700">
                Menampilkan <span className="font-medium">{currentPage}</span> hingga{' '}
                <span className="font-medium">{statusLength === "all" ? akunData.length : statusLength}</span> dari{' '}
                <span className="font-medium">{akunData.length}</span> karyawan
                </div>
                <div className="flex space-x-2">
                <button 
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(prev => prev - 1)}
                className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
                    Previous
                </button>
                
                { pageNumbers.map((page) =>( 
                    <button 
                    key={page}
                    onClick={() => setCurrentPage(page)}
                    className={`px-3 py-1 rounded ${ currentPage === page ? "bg-blue-500 text-white" : "bg-gray-200" }`}>
                    {page}
                    </button>
                ))}
                
                <button 
                    disabled={currentPage === Math.ceil(filteredAkuns.length / itemsPerPage)}
                    onClick={() => setCurrentPage(prev => prev + 1)}
                    className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
                    Next
                </button>
                </div>
            </div>
            </div>

            {/* Add Employee Modal */}
            {showFormModal && <FormAkunModal akunDetail={selectedAkun} statusForm={statusFormModal} setShowFormModal={setShowFormModal} onPostState={initDataKaryawan}/>}

        </div>
        </>
    )
}
